import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material";
import { ActivatedRoute } from "@angular/router";
import { MedicalAppointmenObservationDialogComponent } from "../../dialogs/medical-appointment-observation/medical-appointment-observation-dialog.component";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { MedicalServiceService } from "../../../services/medical-service.service";
import { AuthService } from "../../../services/auth.service";
import { ReceivedLabSampleComponent } from "../../dialogs/received-lab-sample/received-lab-sample.component";
import { MedicalAppointmentCareEditInfo } from "../../../model/medical-appointment-care-edit-info";
import { PracticeRegionPreparationDialogComponent } from "../../dialogs/practice-region-preparation/practice-region-preparation-dialog.component";
import { ReceivedLabSampleDialogComponent } from "../../dialogs/received-lab-sample-dialog/received-lab-sample-dialog.component";
import { StudyReportService } from "src/app/services/study-report/study-report.service";

@Component({
  selector: "app-extraccionista-wizard",
  templateUrl: "./extraccionista-wizard.component.html",
  styleUrls: ["./extraccionista-wizard.component.css"],
})
export class ExtraccionistaWizardComponent implements OnInit {
  loadingAction: boolean;
  loading: boolean;
  medicalAppointmentId: number;
  medicalOrderId: number;
  deliveryDate: string | null = null;
  info: MedicalAppointmentCareEditInfo;
  @ViewChild("receivedLab", { static: false })
  receivedLab: ReceivedLabSampleComponent;

  constructor(
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private authService: AuthService,
    private studyReportService: StudyReportService,
    private medicalServiceService: MedicalServiceService,
    private notificationToastService: NotificationToastService
  ) {}

  async ngOnInit() {
    this.loading = true;
    this.medicalAppointmentId = this.route.snapshot.params.MedicalAppointmentId;
    this.medicalOrderId = this.route.snapshot.params.MedicalOrderId;
    this.info =
      await this.medicalServiceService.getMedicalAppointmentCareEditInfo(
        this.medicalAppointmentId,
        true
      );

    await this.setDeliveryDate();
    this.loading = false;
  }

  async setDeliveryDate() {
    const date = await this.studyReportService.getStudyReportDeliveryDate(
      this.medicalAppointmentId
    );

    if (date) {
      this.deliveryDate = date;
    }
  }

  openMedicalAppointmentObservationDialog(): void {
    this.dialog.open(MedicalAppointmenObservationDialogComponent, {
      width: "50%",
      data: {
        medicalAppointmentId: this.medicalAppointmentId,
        editLastObservation: true,
      },
    });
  }

  verMuestras() {
    this.dialog.open(ReceivedLabSampleDialogComponent, {
      width: "50%",
      data: {
        medicalAppointmentId: this.medicalAppointmentId,
        isAdmission: false,
      },
    });
  }

  async verPreparaciones() {
    const ids = [];
    if (this.info) {
      if (this.info.MedicalAppointmentProcedurePrincipals) {
        this.info.MedicalAppointmentProcedurePrincipals.forEach((element) => {
          if (element.PracticeRegionAditionalId) {
            ids.push(element.PracticeRegionAditionalId);
          } else {
            ids.push(element.PracticeRegionId);
          }
        });
      }

      if (this.info.MedicalAppointmentProcedureAditionals) {
        this.info.MedicalAppointmentProcedureAditionals.forEach((element) => {
          if (element.PracticeRegionAditionalId) {
            ids.push(element.PracticeRegionAditionalId);
          } else {
            ids.push(element.PracticeRegionId);
          }
        });
      }
    }

    this.dialog.open(PracticeRegionPreparationDialogComponent, {
      width: "70%",
      data: ids,
    });
  }

  async finalizeMedicalAppointmentCare() {
    try {
      this.loadingAction = true;
      const physicianId = this.authService.getPhysicianId();
      if (!physicianId) {
        this.notificationToastService.error(
          "Debe ser un profesional para poder finalizar la atención",
          "Atención de turno"
        );
      } else {
        await this.receivedLab.update();
        await this.medicalServiceService.medicalAppointmentCareEnd(
          this.medicalAppointmentId,
          physicianId,
          true
        );

        this.cancel();
      }
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Atención de turno"
      );
    } finally {
      this.loadingAction = false;
    }
  }

  onReAppointmentChange() {
    this.cancel();
  }

  cancel(): void {
    history.back();
  }
}
